import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.setScrollPosition()
  }

  setScrollPosition() {
    const activePill = this.element.querySelector('.sowing-pill.active')
    if (!activePill) return

    const pillRect = activePill.getBoundingClientRect()
    const containerRect = this.element.getBoundingClientRect()

    const scrollLeft = this.element.scrollLeft + pillRect.left - containerRect.left - (containerRect.width / 2) + (pillRect.width / 2)

    this.element.scrollTo({ left: scrollLeft })
  }
}
